export default __webpack_public_path__ + "static/media/game-examples.3b46c74e.yaml";